import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { IParticipatedEventItem } from "../../interfaces"
import { ScrollList, Text } from "../."
import { Badge } from "./Badge"

interface IBadgesContainerProps {
	badgesFromEvents: IParticipatedEventItem[] | undefined
	orientation?: "vertical" | "horizontal"
}

export const BadgesContainer = observer(({ badgesFromEvents }: IBadgesContainerProps) => {
	const { t } = useTranslation()

	if (!badgesFromEvents) return null

	return (
		<div className="flex h-[100%] flex-col">
			<Text variant="normal-bold" style="mb-[23px]">
				{t("profile.collected_badges")}
			</Text>

			<ScrollList
				items={badgesFromEvents}
				renderItem={(item) => <Badge key={item.id} event={item} />}
				listEmptyComponent={<Text>{t("profile.no_collected_badges")}</Text>}
			/>
		</div>
	)
})
